import ErrorBoundary from 'components/Layout/ErrorBoundary/ErrorBoundary';
import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';
import { usePermission } from 'hooks/usePermission';
import Home from 'pages/Home/Home';
import React from 'react';
import { Switch, useLocation } from 'react-router';
import Error from './404/Error';
import Activate from './Auth/Activate/Activate';
import ForgotPassword from './Auth/ForgotPassword/ForgotPassword';
import Login from './Auth/Login/Login';
import Register from './Auth/Register/Register';
import ResetPassword from './Auth/ResetPassword/ResetPassword';
import Feedback from './Feedback/Feedback';
import AssessmentOverview from './Growth/AssessmentOverview/AssessmentOverview';
import GrowthPortfolio from './Growth/GrowthPortfolio/GrowthPortfolio';
import Judge from './Growth/Judge/Judge';
import MyReflections from './Growth/MyReflections/MyReflections';
import Reflect from './Growth/Reflect/Reflect';
import StudentOverview from './Growth/StudentOverview/StudentOverview';
import BuildingBlocks from './Library/BuildingBlocks/BuildingBlocks';
import Courses from './Library/Courses/Courses';
import Groowtorials from './Library/Groowtorials/Groowtorials';
import Projects from './Library/Projects/Projects';
import MLScan from './MLScan/MLScan';
import SelectTheme from './MLScan/components/SelectTheme';
import MyPortfolios from './Portfolio/MyPortfolios/MyPortfolio';
import MyWork from './Portfolio/MyWork/MyWork';
import PublicPortfolio from './Portfolio/PublicPortfolio/PublicPortfolio';
import Scan from './Scan/Scan';
import MyCourses from './Workspace/MyCourses/MyCourses';
import MyMessages from './Workspace/MyMessages/MyMessages';
import MyProjects from './Workspace/MyProjects/MyProjects';
import ProjectDetails from './Workspace/ProjectDetails/ProjectDetails';
import ThemeBuilder from './Workspace/ThemeBuilder/ThemeBuilder';
import TrainingBuilder from './Workspace/TrainingBuilder/TrainingBuilder';
import TrainingDetails from './Workspace/TrainingDetails/TrainingDetails';

export default function Routes() {
  const { pathname } = useLocation();

  const isExtern = usePermission(['Extern']);

  return (
    <ErrorBoundary key={pathname}>
      <Switch>
        {/* auth */}
        <UnauthenticatedRoute path="/inloggen/:shareCode?" component={Login} />
        <UnauthenticatedRoute path="/proefaccount" component={Register} />
        <UnauthenticatedRoute path="/activeren" component={Activate} />
        <UnauthenticatedRoute
          path="/extern-uitnodiging/:shareCode"
          component={Register}
        />
        <UnauthenticatedRoute
          path="/wachtwoord/vergeten"
          component={ForgotPassword}
        />
        <UnauthenticatedRoute
          path="/wachtwoord/herstellen"
          component={ResetPassword}
        />
        {/* Library */}
        <AuthenticatedRoute
          path="/bibliotheek/bouwstenen"
          exact
          component={BuildingBlocks}
        />
        <AuthenticatedRoute
          path="/bibliotheek/trainingen"
          exact
          component={Courses}
        />
        <AuthenticatedRoute
          path="/bibliotheek/groowtorials"
          exact
          component={Groowtorials}
        />
        <AuthenticatedRoute
          path="/bibliotheek/projecten"
          exact
          component={Projects}
        />
        {/* Workspace */}
        <AuthenticatedRoute
          path="/werkplaats/mijn-projecten"
          exact
          component={MyProjects}
        />
        <AuthenticatedRoute
          path="/werkplaats/mijn-trainingen"
          exact
          component={MyCourses}
        />
        <AuthenticatedRoute
          path="/werkplaats/mijn-berichten"
          exact
          component={MyMessages}
        />
        <AuthenticatedRoute
          path="/werkplaats/project-details/:projectId/:channelId?"
          component={ProjectDetails}
        />
        <AuthenticatedRoute
          path="/werkplaats/thema-bouwer"
          exact
          component={ThemeBuilder}
        />
        <AuthenticatedRoute
          path="/werkplaats/thema-bouwer/:themeId"
          exact
          component={ThemeBuilder}
        />
        <AuthenticatedRoute
          path="/werkplaats/training-bouwer"
          exact
          component={TrainingBuilder}
        />
        <AuthenticatedRoute
          path="/werkplaats/training-bouwer/:trainingId"
          exact
          component={TrainingBuilder}
        />
        <AuthenticatedRoute
          path="/werkplaats/training-details/:trainingId/:sessionId?"
          exact
          component={TrainingDetails}
        />
        {/* show */}
        <AuthenticatedRoute path="/show/mijn-werk" exact component={MyWork} />
        <AuthenticatedRoute
          path="/show/show-portfolios"
          exact
          component={MyPortfolios}
        />
        <UnauthenticatedRoute
          path="/publiek-portfolio/:shareCode"
          exact
          component={PublicPortfolio}
        />
        {/* Growth */}
        <UnauthenticatedRoute
          path="/groei/mijn-reflecties"
          exact
          component={MyReflections}
        />
        <UnauthenticatedRoute
          path="/groei/mijn-beoordelingen"
          exact
          component={AssessmentOverview}
        />
        <UnauthenticatedRoute
          path="/groei/groeiportfolio"
          exact
          component={GrowthPortfolio}
        />
        <UnauthenticatedRoute
          path="/groei/beoordelen"
          exact
          component={AssessmentOverview}
        />
        <UnauthenticatedRoute
          path="/groei/feedback-geven"
          exact
          component={Judge}
        />
        <UnauthenticatedRoute
          path="/groei/studenten-overzicht"
          exact
          component={StudentOverview}
        />
        <UnauthenticatedRoute
          path="/groei/beoordelen/:assessmentId"
          exact
          component={Feedback}
        />
        <UnauthenticatedRoute
          path="/groei/reflecteren/:projectId/:checkpointId?/:peerId?"
          exact
          component={Reflect}
        />
        {/* Other */}
        <AuthenticatedRoute
          path="/"
          exact
          component={isExtern ? MyProjects : Home}
        />
        <AuthenticatedRoute path="/scan" exact component={Scan} />
        <AuthenticatedRoute
          path="/mlscan/:projectId"
          exact
          component={MLScan}
        />
        <AuthenticatedRoute
          path="/select-theme"
          exact
          component={SelectTheme}
        />
        <AuthenticatedRoute path="/404" component={Error} />
        <UnauthenticatedRoute component={Error} />
      </Switch>
    </ErrorBoundary>
  );
}
